import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/company.service";

export const requestInboundMailThunk = createAsyncThunk(
  "company/requestInboundMail",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.requestInboundMail();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Request inbound mail failed"
      );
    }
  }
);

export const getCompanyInfoThunk = createAsyncThunk(
  "company/getCompanyInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getCompanyInfo();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get company info failed"
      );
    }
  }
);

export const getCompaniesThunk = createAsyncThunk(
  "company/getCompanies",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getCompanies();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get companies failed"
      );
    }
  }
);
